const overlayBtn = document.querySelector('[data-trigger="overlay"]');
const overlayEl = document.querySelectorAll('.overlay');
const closeBtn = document.querySelectorAll('.btn-close');

if ( overlayBtn ) {
  overlayBtn.addEventListener('click', (e) => {
    e.preventDefault();

    if ( overlayEl ) {
      overlayEl.forEach(el => {
        if (el.classList.contains('active')) {
          el.classList.remove('active');
          document.body.classList.remove('js-active');
        } else {
          el.classList.add('active');
          document.body.classList.add('js-active');
        }
      });
    } else {
      return ;
    }
  });
}




// WEBPACK FOOTER //
// ./themes/default/assets/js/overlay.js